import React from "react";
import PropTypes from "prop-types"; //  Import PropTypes
import ProfileBiodata from "../layouts/ProfileBiodata";
import { useTranslation } from 'react-i18next';
const AllBiodataMobile = ({handlePageChange, currentPage, nextPage, prevPage, count, data, screenWidth, user, clickedBiodata, vendorId, selectedBiodata, setSelectedBiodata, onRefresh, setIsBookOpen}) => {
  const { t } = useTranslation();


  const handleClickBiodata = (biodata) => {
    clickedBiodata(biodata);
  };

  const handleBookClick = (biodata) => {
    clickedBiodata(biodata);
    setIsBookOpen(true);
  };



  return (
    <>
      {data.length > 0 ? (
        data.map((item, index) => (
          <div key={index} className="rounded mb-3 text-dark">

            <ProfileBiodata packageId={data[0].shared_biodata_package_id} item={item} type={user.type} vendorId={vendorId} onClickBiodata={handleClickBiodata} selectedBiodata={selectedBiodata} setSelectedBiodata={setSelectedBiodata} onRefresh={onRefresh} onClick={handleBookClick}/>

            
          </div>
        
        ))
      ) : (
        <div className="p-3 rounded bg-white text-secondary mb-3">
          <p>{t("No Data")}</p>
        </div>
      )}

      {/* Pagination Controls */}
      <div className="mt-3">
        <button
          className="btn btn-secondary me-2"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          {t("Previous")}
        </button>
        <span>{t("Page")} {currentPage} {t("of")} {Math.ceil(count / 10)}</span>
        <button
          className="btn btn-secondary ms-2"
          onClick={() => handlePageChange(currentPage + 1)}
        >
          {t("Next")}
        </button>
      </div>
    </>
  )
}

AllBiodataMobile.propTypes = {
  user: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  vendorId: PropTypes.number.isRequired,
  clickedBiodata: PropTypes.func.isRequired,
  setSelectedBiodata: PropTypes.func.isRequired,
  selectedBiodata: PropTypes.object,
  onRefresh: PropTypes.func.isRequired,
  screenWidth: PropTypes.number.isRequired,
  setIsBookOpen: PropTypes.func.isRequired,

  handlePageChange: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  prevPage: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
};

export default AllBiodataMobile